import React, { FC } from 'react'
import ReactSelect from 'react-select'
import { EntityId } from '@reduxjs/toolkit'
import { reactSelectDarkmode } from '@config/style.config'
import { useTheme } from '@config/theme.config'
import CreatableSelect from 'react-select/creatable'

export const AppSelectComponent: FC<{
  options: { id: EntityId; label: string }[]
  onSelectChange: (value: EntityId | null) => void
  placeholder?: string
  defaultId?: EntityId
  valueId?: EntityId
  className?: string
  customStyles?: any
  isClearable?: boolean
  isCreatable?: boolean
  isOpenedByDefault?: boolean
  isDisabled?: boolean
}> = ({
  options,
  onSelectChange,
  defaultId,
  placeholder = '',
  className = '',
  customStyles = {},
  valueId,
  isClearable = false,
  isOpenedByDefault = false,
  isCreatable = false,
  isDisabled = false,
}) => {
  const optionsList = options.map((option) => ({
    value: option.id,
    label: option.label,
  }))
  const { theme } = useTheme()
  const SelectComponent = isCreatable ? CreatableSelect : ReactSelect

  return (
    <SelectComponent
      isDisabled={isDisabled}
      isClearable={isClearable}
      defaultValue={
        !!defaultId
          ? optionsList.find((option) => option.value == defaultId)
          : null
      }
      value={
        !!valueId
          ? optionsList.find((option) => option.value === valueId)
          : null
      }
      placeholder={placeholder}
      className={className}
      options={optionsList}
      defaultMenuIsOpen={isOpenedByDefault}
      styles={reactSelectDarkmode(theme, customStyles)}
      onChange={(option) => onSelectChange(option ? option.value : null)}
    />
  )
}
